export const iconFontAwesomeLogisticsRoad = (
	<i className="fa-solid fa-road"></i>
);
